"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    FileWiredSolid: function() {
        return FileWiredSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const FileWiredSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M6 3C6 1.89543 6.89543 1 8 1H12.5858C13.1162 1 13.6249 1.21071 14 1.58579L17.4142 5C17.7893 5.37507 18 5.88378 18 6.41421V13C18 14.1046 17.1046 15 16 15H13V17.1707C13.8524 17.472 14.528 18.1476 14.8293 19H22C22.5523 19 23 19.4477 23 20C23 20.5523 22.5523 21 22 21H14.8293C14.4175 22.1652 13.3062 23 12 23C10.6938 23 9.58254 22.1652 9.17071 21H2C1.44772 21 1 20.5523 1 20C1 19.4477 1.44772 19 2 19H9.17071C9.47199 18.1476 10.1476 17.472 11 17.1707V15H8C6.89543 15 6 14.1046 6 13V3ZM12 21C11.4477 21 11 20.5523 11 20C11 19.4477 11.4477 19 12 19C12.5523 19 13 19.4477 13 20C13 20.5523 12.5523 21 12 21ZM12.5 3L16 6.5H12.5V3Z",
        fill: "currentColor"
    })
}), "FileWiredSolid");
const _default = FileWiredSolid;
